import { SET_GYM_ATTRIBUTES, SET_GYMS, SET_GYM, RESET_GYMS } from '../types/types';

export const setGyms = (value, count) => {
  return {
    type: SET_GYMS,
    payload: { data: value, count: count},
  };
};

export const setGym = (value) => {
  return {
    type: SET_GYM,
    payload: { data: value },
  };
};

export const setGymAttributes = (value) => {
    return {
      type: SET_GYM_ATTRIBUTES,
      payload: { data: value },
    };
  };

// export const resetGyms = () => {
//   return {
//     type: RESET_GYMS,
//     payload: { data: value },
//   };
// };
